import React from 'react';
import { TextField, InputAdornment } from '@mui/material';

// Reusable Input Component for Measurements
const MmInput = ({ value, onChange, placeholder = "mm", width = '80px', type = "number", adornment = "mm" }) => (
    <TextField
        placeholder={placeholder}
        size="small"
        type={type}
        value={value || ''}
        onChange={onChange}
        InputProps={{
            endAdornment: <InputAdornment position="end" sx={{ '& .MuiTypography-root': { fontSize: '12px' } }}>{adornment}</InputAdornment>,
        }}
        sx={{
            width: width,
            '& .MuiOutlinedInput-root': { borderRadius: 0 },
            '& .MuiOutlinedInput-input': { padding: '8px 8px 8px 14px', fontSize: '14px' }
        }}
    />
);

export default MmInput;
